module.exports = __webpack_public_path__ + "static/media/JH.9dfca25d.PNG";